module.exports = __webpack_public_path__ + "arrow-up-right.svg?1d0f520a2c64b73bb18352674bbcb541";